import { render } from "./WindowNotification.vue?vue&type=template&id=a2ac5bf2"
import script from "./WindowNotification.vue?vue&type=script&lang=js"
export * from "./WindowNotification.vue?vue&type=script&lang=js"

import "./WindowNotification.vue?vue&type=style&index=0&id=a2ac5bf2&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__